module.exports = {
  visibility: true,
  locked: false,
  defaultItems: {
    '17000800': 1
  },
  titleFormatOff: {
    placeholder: '### __.### (e.g. "112 FG.767")',
    //formatter: '[0-9A-Z]',
    validator: '^[0-9]{3}[ ]?[A-Z]{2}\.?[0-9]{3}$',
    validatorDescription: {
      en: 'Project name should follow the pattern ### __.### (e.g. "112 FG.767")',
      de: 'Project name should follow the pattern ### __.### (e.g. "112 FG.767")',
    }
  },
  requireAttachments: [
    {
      'OR': ['/.*\.zip$/'],
      'message': {
        de: 'Bitte laden Sie den erstellten Zip-Ordner aus Ihrer SKT-Box hoch!',
        en: 'Please upload the ZIP folder from your SKT box!',
        es: 'Por favor, sube la carpeta zip creada desde tu caja SKT!',
        fr: 'Veuillez charger fichier Zip de votre Box SKT!',
        pt: 'Carregue o seu ficheiro zip criado a partir da sua SKT Box!',
        it: 'Carica la cartella zip creata dal tuo SKT Box!',
        ru: 'Загрузите созданный архив папки из поля SKT!'
      }
    }
  ],
  // intro: require('./JawModelIntro.html'),
  title: {
    en: 'Chew',
    de: 'Chew',
    es: 'Chew',
    fr: 'Chew',
    pt: 'Chew',
    it: 'Chew',
    ru: 'Chew'
  },
  image: '/img/Button-Chew-Plattform.png',
  icon: 'teeth',
  iconPrefix: 'fas',
  iconColor: 'green',
  color: 'green-light',
  badgeColor: 'lightgreen',
  orderStatuses: [
    {
      conditions: {
        status: 0, // draft
      },
      style: 'light',
      icon: 'fa fa-inbox',
      label: 'Reports.statusReceived',
      name: 'received',
      title: 'Reports.statusReceived',
      description: 'Reports.statusReceivedDescr',
      optional: false,
      terminate: false,
    },
    {
      // order excepted
      conditions: {
        status: 1, // booked
        orderstatus: 'processing'
      },
      style: 'primary',
      icon: 'fa fa-clock',
      label: 'Reports.statusInProgress',
      name: 'inprogress',
      title: 'Reports.statusInProgress',
      description: 'Reports.statusInProgressDescr',
      optional: false,
      terminate: false,
    },
    {
      conditions: {
        status: 3, // Cancelled
      },
      style: 'dark',
      icon: 'fa fa-inbox',
      label: 'Orders.statusCancelled',
      name: 'cancelled',
      title: 'Orders.statusCancelled',
      description: 'Orders.statusCancelledDescr',
      optional: true,
      terminate: true,
    },
    {
      // production started
      conditions: {
        status: 1, // booked
        orderstatus: 'finished'
      },
      style: 'info',
      icon: 'fa fa-cogs',
      label: 'Reports.statusInProduction',
      name: 'inproduction',
      title: 'Reports.statusInProduction',
      description: 'Reports.statusInProduction',
      optional: false,
      terminate: false,
    },
    {
      conditions: {
        status: 4, // Complete
      },
      style: 'secondary',
      icon: 'fa fa-inbox',
      label: 'Reports.statusCompleted',
      name: 'completed',
      title: 'Reports.statusCompleted',
      description: 'Reports.statusCompletedDescr',
      optional: false,
      terminate: false,
    }
  ],
  tabs: [
    {
      id: 'masterdata',
      type: 'form',
      title: {
        en: 'Masterdata',
        de: 'Stammdaten',
        es: 'Datos maestros',
        fr: 'Données de base',
        pt: 'Dados existentes',
        it: 'Dati master',
        ru: 'Основные данные'
      },
      form: require('./OrderForm.js')
    },
    {
      id: 'attachments',
      type: 'attachments',
      title: {
        en: 'Attachments',
        de: 'Anhänge',
        es: 'Archivos adjuntos',
        fr: 'Pièces jointes',
        pt: 'Anexos',
        it: 'Allegati',
        ru: 'Приложения'
      },
      intro: {
        de: 'Bitte laden Sie hier den erstellten Zip-Ordner aus Ihrer SKT-Box hoch!',
        en: 'Please upload the ZIP folder from your SKT box!',
        es: 'Por favor, cargue aquí desde su SKT Box la carpeta ZIP que ha creado.',
        fr: 'Veuillez charger ici fichier Zip de votre Box SKT!',
        pt: 'Carregue o seu ficheiro zip criado a partir da sua SKT Box!',
        it: 'Carica qui la cartella ZIP creata dal tuo SKT Box!',
        ru: 'Загрузите созданный архив папки из поля SKT!'
      },
      classes: {
        attachment: {
          fileLimit: 1,
          requires: 1,
          fileTypes: ['.zip'],
          fileNames: "^[0-9]{3,5}_[0-9]{6,8}.zip$",
          errorMessage: {
            en: 'The filename does not match the expected format (e.g. 12345_123456.zip). Have you uploaded the correct file?',
            de: 'Der Dateiname entspricht nicht dem korrekten Format. (z.B. 12345_123456.zip). Haben Sie die richtige Datei hochgeladen?',
            es: 'El nombre del archivo no tiene el formato adecuado (por ejemplo, 12345_123456.zip). ¿Ha cargado el archivo correcto?',
            fr: 'Le nom du fichier ne correspond pas au format correct (par ex. 12345_123456.zip). Avez-vous téléchargé le fichier correct?',
            pt: 'O nome do ficheiro corresponde ao formato correto (p. ex. 12345_123456.zip). Carregou o ficheiro correto?',
            it: 'Il nome del file non corrisponde al formato previsto (e.g. 12345_123456.zip). È stato caricato il file corretto? ',
            ru: 'Имя файла не соответствует формату (например, 12345_123456.zip). Загружен правильный файл?'
          }
        }
      }
    },
    {
      id: 'cart',
      type: 'cart',
      title: {
        en: 'Cart',
        de: 'Warenkorb',
        es: 'Cesta de la compra',
        fr: 'Panier',
        pt: 'Cesto',
        it: 'Carrello',
        ru: 'Корзина'
      },
      hidePrices: false,
      hideOrdered: true,
      requireShipping: false,
      orderDialog: [
        {
          id: 'terms',
          intro: {
            style: 'alert alert-info',
            en: 'Still got enough chew units? Under "order addons", you can easily order new chew units.',
            de: 'Haben Sie noch genügend Kau-Units? Unter "Zusatzprodukte bestellen" können Sie neue Kau-Units ordern.',
            es: '¿Todavía le quedan suficientes unidades de masticación? En «pedir complementos» puede realizar fácilmente el pedido de nuevas unidades de masticación.',
            fr: 'Avez-vous encore assez d`unités de mastications? Sous "Commander des produits supplémentaires" vous pouvez commander des unités de mastication.',
            pt: 'Dispõe de unidades de mastigação suficientes? Em "Encomendar produtos adicionais", poderá encomendar novas unidades da mastigação.',
            it: 'Ha ancora a disposizione sufficienti unità di masticazione? Alla voce "ordina prodotti supplementari", è possibile ordinare facilmente altre unità di masticazione.',
            ru: 'У вас еще достаточно жевательных блоков? В разделе «Заказать дополнительную продукцию» можно заказать новые жевательные блоки.'
          },
          form: [
            {
              id: 'terms',
              type: 'checkbox',
              checkValue: true,
              required: true,
              label: {
                en: 'I have read and accepted the <a href="https://www.orehab-minds.com/agb/" target="_blank">terms of service</a>.',
                de: 'Ich habe die <a href="https://www.orehab-minds.com/agb/" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiert.',
                es: 'He leído y aceptado las <a href="https://www.orehab-minds.com/agb/" target="_blank">Condiciones Generales</a>.',
                fr: 'J`ai lu les <a href="https://www.orehab-minds.com/agb/" target="_blank">conditions générales de vente</a> et je les accepte.',
                pt: 'Li e aceito os <a href="https://www.orehab-minds.com/agb/" target="_blank">termos e condições gerais</a>.',
                it: 'Ho letto e accetto le <a href="https://www.orehab-minds.com/agb/" target="_blank">condizioni generali di acquisto</a>.',
                ru: 'Я прочитал(а) и принял(а) <a href="https://www.orehab-minds.com/agb/" target="_blank">Общие условия использования</a>.'
              }
            },
            {
              id: 'privacy',
              type: 'checkbox',
              required: true,
              checkValue: true,
              label: {
                en: 'I have read and accepted the <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">pricacy policy</a>.',
                de: 'Ich habe die <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">Datenschutzhinweise</a> gelesen und akzeptiert.',
                es: 'He leído y aceptado la <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">Política de Privacidad</a>.',
                fr: 'J`ai lu les <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">données de protection des données</a> et je les accepte.',
                pt: 'Li e aceito a <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">política de privacidade</a>.',
                it: 'Ho letto e accetto <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">l`informativa sulla protezione dei dati personali</a>.',
                ru: 'Я прочитал(а) и принял(а) <a href="https://www.orehab-minds.com/datenschutz/" target="_blank">Положения по защите данных</a>.'
              }
            }
          ]
        }
      ]
    }
  ]
}
